import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var ExhibitorProfile = /*#__PURE__*/function () {
  function ExhibitorProfile(context) {
    _classCallCheck(this, ExhibitorProfile);

    this.context = context;
  }

  _createClass(ExhibitorProfile, [{
    key: "getSectorsByGallery",
    value: function getSectorsByGallery(accoundId, params) {
      return this.context.http.get("/msvc/v1/exhibitorprofile/items/".concat(accoundId, "/admittedSectors"), params);
    }
  }]);

  return ExhibitorProfile;
}();

export default ExhibitorProfile;